module.exports = __webpack_public_path__ + "static/img/ex_w2.05dd976.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_w2.jpg
// module id = 9RwL
// module chunks = 1